import BaseAPIService from '@/services/baseAPIService'

export default class CommunicationAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  // Communication Log
  getCommunicationLog(id)                                  { return this.httpClient.get(`/communication/communicationlogs/${id}`) }
  
  // Notifications
  getNotificationSummary()                                 { return this.httpClient.get(`/communication/notifications/summary`) }
  getNotification(id)                                      { return this.httpClient.get(`/communication/notifications/${id}`) }
  updateNotification(id, data)                             { return this.httpClient.put(`/communication/notifications/${id}`, data) }

  updateNotificationBatch(data)                            { return this.httpClient.put(`/communication/notifications`, data) }


}
